import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { AuthProvider } from "@/contexts/AuthContext";
import { EligibilityProvider } from "@/contexts/EligibilityContext";
import { DemoModalProvider } from "@/contexts/DemoModalContext";
import Navbar from "@/components/Navbar";
import Index from "./pages/Index";
import SignIn from "./pages/SignIn";
import Dashboard from "./pages/Dashboard";
import EligibilityAssessment from "./pages/EligibilityAssessment";
import HowItWorks from "./pages/HowItWorks";
import Pathways from "./pages/Pathways";
import Enterprise from "./pages/Enterprise";
import Resources from "./pages/Resources";
import VerificationConfirmation from "./pages/VerificationConfirmation";
import ConsultationBooking from "./pages/ConsultationBooking";
import DocumentManagement from "./pages/DocumentManagement";
import AccountSettings from "@/components/account/AccountSettings";
import RequestDemoModal from "@/components/demo/RequestDemoModal";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <AuthProvider>
        <EligibilityProvider>
          <DemoModalProvider>
            <TooltipProvider>
              <Routes>
                {/* Consultation booking route outside of the main layout */}
                <Route path="/consultation-booking" element={
                  <div className="min-h-screen bg-background">
                    <ConsultationBooking />
                  </div>
                } />
                
                {/* All other routes with Navbar */}
                <Route
                  path="/*"
                  element={
                    <>
                      <Navbar />
                      <Routes>
                        <Route path="/signin" element={<SignIn />} />
                        <Route path="/signup" element={<SignIn />} />
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/documents" element={<DocumentManagement />} />
                        <Route path="/eligibility" element={<EligibilityAssessment />} />
                        <Route path="/how-it-works" element={<HowItWorks />} />
                        <Route path="/pathways" element={<Pathways />} />
                        <Route path="/resources" element={<Resources />} />
                        <Route path="/enterprise" element={<Enterprise />} />
                        <Route path="/verify-success" element={<VerificationConfirmation />} />
                        <Route path="/account" element={<AccountSettings />} />
                        <Route path="/" element={<Index />} />
                        <Route path="*" element={<Navigate to="/" replace />} />
                      </Routes>
                    </>
                  }
                />
              </Routes>
              <RequestDemoModal />
              <Toaster />
              <Sonner />
            </TooltipProvider>
          </DemoModalProvider>
        </EligibilityProvider>
      </AuthProvider>
    </BrowserRouter>
  </QueryClientProvider>
);

export default App;